import { createSelector } from '@reduxjs/toolkit';
import { EOfferSeller } from '../../../../packages/api-models/common/json_query';
import { selectOfferType } from 'shared/selectors/jsonQuery';
import { FOfferType, isSuburban } from '../../../../packages/JsonQuery';

export const COMMON_OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Собственник', value: EOfferSeller.Homeowner },
  { label: 'Агент', value: EOfferSeller.Agent },
];

export const FLAT_SELLER_OPTIONS = [...COMMON_OPTIONS, { label: 'Застройщик', value: EOfferSeller.Builder }];

export const SUBURBAN_SELLER_OPTIONS = FLAT_SELLER_OPTIONS;

export const selectOfferSellerOptions = createSelector(selectOfferType, offerType => {
  if (offerType === FOfferType.Flat) {
    return FLAT_SELLER_OPTIONS;
  }

  if (isSuburban(offerType)) {
    return SUBURBAN_SELLER_OPTIONS;
  }

  return COMMON_OPTIONS;
});
